export default __webpack_public_path__ + "static/media/episode-3.257ee1aa.jpg";